import React from 'react';
import { Section } from './ui/Section';
import { Brain, Moon, BatteryCharging } from 'lucide-react';
import { motion } from 'framer-motion';
function MechanismCard({
  icon: Icon,
  title,
  subtitle,
  desc,
  index
}: any) {
  return <motion.div initial={{
    opacity: 0,
    y: 50,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    y: 0,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1,
    duration: 0.6,
    type: 'spring'
  }} className="bg-brand-charcoal p-8 rounded-2xl border border-white/5 shadow-md hover:shadow-xl hover:border-brand-indigo/30 transition-all duration-300 group relative overflow-hidden" data-id="element-215">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-indigo/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-216" />

      <div className="relative z-10" data-id="element-217">
        <div className="w-14 h-14 bg-brand-indigo/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-indigo/20 transition-colors group-hover:scale-110 duration-300" data-id="element-218">
          <Icon className="text-brand-indigo" size={28} data-id="element-219" />
        </div>

        <h3 className="font-heading text-2xl text-white mb-2 uppercase tracking-wide" data-id="element-220">
          {title}
        </h3>
        <p className="text-brand-amber font-bold text-sm uppercase tracking-wider mb-4" data-id="element-221">
          {subtitle}
        </p>

        <ul className="text-slate-400 text-lg leading-relaxed list-disc pl-5 space-y-2" data-id="element-222">
          {desc.map((item: string, i: number) => <li key={i} data-id="element-223">{item}</li>)}
        </ul>
      </div>
    </motion.div>;
}
export default function MechanismSection() {
  return <Section id="mechanism" className="bg-brand-dark" data-id="element-224">
      <div className="text-center mb-16" data-id="element-225">
        <h2 className="font-heading text-4xl md:text-6xl text-white mb-4 uppercase tracking-wide" data-id="element-226">
          El Triángulo{' '}
          <span className="text-brand-indigo border-b-4 border-brand-indigo relative inline-block" data-id="element-227">
            NOCHE
            <motion.span initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            delay: 0.5,
            duration: 0.8
          }} className="absolute bottom-0 left-0 h-1 bg-brand-amber" data-id="element-228" />
          </span>
        </h2>
        <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto" data-id="element-229">
          Un protocolo de 14 noches para re-entrenar a tu cerebro:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-230">
        <MechanismCard icon={Brain} title="Desactivar" subtitle="Fase 1 (Días 1-4)" desc={['Aprende a bajar la vigilancia antes de tocar la almohada.', 'Rompe la asociación Cama = Alerta.', "Técnicas de 'descarga mental' para vaciar la cabeza."]} index={0} data-id="element-231" />
        <MechanismCard icon={Moon} title="Re-asociar" subtitle="Fase 2 (Días 5-10)" desc={['Convierte la cama en un lugar neutro de nuevo.', 'Qué hacer exactamente si te despiertas (sin frustrarte).', 'Cómo volver a dormir sin intentarlo.']} index={1} data-id="element-232" />
        <MechanismCard icon={BatteryCharging} title="Consolidar" subtitle="Fase 3 (Días 11-14)" desc={['Protege tu sueño de recaídas.', 'Rutinas mínimas viables para días difíciles.', 'Recupera la confianza en tu capacidad de dormir.']} index={2} data-id="element-233" />
      </div>
    </Section>;
}